import { IEmployment } from '@/context/borrower';

export function isEmploymentComplete(
    employment: IEmployment,
    isNovatedLease?: boolean
): boolean {
    const {
        occupation,
        employerPhone,
        employerLookupDetails,
        years: employmentYears,
        months: employmentMonths,
    } = employment;

    if (!isNovatedLease && (occupation === null || occupation === undefined))
        return false;
    if (employerLookupDetails === undefined) return false;
    if (
        employerPhone === null ||
        employerPhone === undefined ||
        employerPhone.length < 10
    )
        return false;

    if (
        employmentYears === null ||
        (employmentYears === undefined &&
            (employmentMonths === null || employmentMonths === undefined))
    )
        return false;

    return true;
}
